import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import PrivateRoute from '../Common/PrivateRoute';
import Rewards from './Rewards';
import RewardsIdentificationPage from './Rewards/RewardsIndetificationPage';

import UsageStatus from './UsageStatus';
import AuthenticationConfig from './AuthenticationConfig/AuthenticationConfig';
import AutoPaymentReset from './AutoPaymentReset';
import AuthenticationConfigIdentificationPage from './AuthenticationConfig/IdentificationPage';
import IpManagement from './Management/IpManagement';
import IpManagementIdentificationPage from './Management/IpManagement/IpManagementIdentificationPage';
import UserInfoModification from './Management/UserInfoModification';
import UserInfoModificationIdentificationPage from './Management/UserInfoModification/UserInfoModificationIdentificationPage';
import Refund from './Management/Refund';
import Withdrawal from './Management/Withdrawal';
import WithdrawalIdentificationPage from './Management/Withdrawal/WithdrawalIdentificationPage';
import TaxInvoice from './TaxInvoice';
import AutoPaymentRequest from './Management/AutoPaymentRequest';

import './myPcBang.scss';
import {WithdrawalCompletion} from './Management/Withdrawal/WithdrawalCompletion';
import SideNavBar from '../Common/SideNavBar';
import {Layout} from '../Common';

const menus = [
  {
    path: '/my-pc-bang/management',
    name: 'PC방 관리',
    submenus: [
      {path: '/my-pc-bang/management/rewards/identification', name: '게임별 혜택 설정'},
      {path: '/my-pc-bang/management/ip-management', name: 'IP 관리'},
      {path: '/my-pc-bang/management/user-info-modification', name: '가입정보 수정'},
      {path: '/my-pc-bang/management/withdrawal', name: '회원탈퇴'},
    ],
  },
  {
    path: '/my-pc-bang/usage-status/payment-and-billing',
    name: '결제 및 사용 현황',
    submenus: [
      {path: '/my-pc-bang/usage-status/payment-and-billing', name: '결제 및 사용 내역'},
      {path: '/my-pc-bang/usage-status/auto-payment', name: '자동결제신청/변경'},
      {path: '/my-pc-bang/usage-status/auto-payment-reset', name: '자동결제 재인증'},
      {path: '/my-pc-bang/usage-status/refund', name: '결제취소/환불신청'},
    ],
  },
  {path: '/my-pc-bang/tax-invoice', name: '세금계산서'},
  {path: '/my-pc-bang/authentication-config', name: '보안관리'},
];

class MyPcBang extends Component {
  render() {
    return (
      <Layout className="page__my-pc-bang">
        <SideNavBar title="MY PC방" menus={menus} />
        <PrivateRoute
          path="/my-pc-bang/management/ip-management/identification"
          exact
          component={IpManagementIdentificationPage}
        />
        <PrivateRoute
          path="(/my-pc-bang/management|/my-pc-bang/management/ip-management)"
          exact
          component={IpManagement}
        />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/management/user-info-modification"
          exact
          component={UserInfoModification}
        />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/management/user-info-modification/identification"
          exact
          component={UserInfoModificationIdentificationPage}
        />
        <PrivateRoute path="/my-pc-bang/usage-status/refund" component={Refund} />
        <PrivateRoute path="/my-pc-bang/usage-status/auto-payment" exact component={AutoPaymentRequest} />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/management/withdrawal"
          exact
          component={Withdrawal}
        />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/management/rewards/identification"
          exact
          component={RewardsIdentificationPage}
        />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/management/rewards"
          exact
          component={Rewards}
        />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/management/withdrawal/identification"
          exact
          component={WithdrawalIdentificationPage}
        />
        <Route path="/my-pc-bang/management/withdrawal/completion" exact component={WithdrawalCompletion} />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/usage-status"
          exact
          component={UsageStatus}
        />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/usage-status/payment-and-billing"
          component={UsageStatus}
        />
        <PrivateRoute
          path="/my-pc-bang/authentication-config/identification"
          exact
          component={AuthenticationConfigIdentificationPage}
        />
        <PrivateRoute path="/my-pc-bang/authentication-config" exact component={AuthenticationConfig} />
        <PrivateRoute path="/my-pc-bang/usage-status/auto-payment-reset" exact component={AutoPaymentReset} />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM', 'CLOSED']}
          path="/my-pc-bang/tax-invoice/:year?"
          exact
          component={TaxInvoice}
        />
      </Layout>
    );
  }
}

export default MyPcBang;
